import { useState, useEffect } from "react";

function useCountdown(expiresAt) {
  const [progress, setProgress] = useState(0);
  const [formattedTime, setFormattedTime] = useState("");
  const [restartTrigger, setRestartTrigger] = useState(0); // Add a trigger for restarts

  useEffect(() => {
    if (!expiresAt) return;

    const endTime = new Date(expiresAt).getTime();
    const totalDuration = endTime - Date.now();

    const interval = setInterval(() => {
      const currentTime = Date.now();
      const remainingTime = Math.max(0, endTime - currentTime);
      const newProgress = ((totalDuration - remainingTime) / totalDuration) * 100;

      setFormattedTime(formatTime(remainingTime));
      setProgress(newProgress);

      if (remainingTime <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, restartTrigger]); // Restart the countdown when the trigger changes

  function restart() {
    setProgress(0); // Reset progress
    setRestartTrigger((prev) => prev + 1); // Increment the trigger to restart the countdown
  }

  return { formattedTime, progress, restart };
}

function formatTime(ms) {
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export default useCountdown;
